import { useEffect } from "react"

const MobileAuth = () => {
	const params = new URLSearchParams(window.location.search)
	const authorizeUrl = params.get('authorize')
	const authResult = params.get('auth') || params.get('authResult')

	useEffect(() => {
		if (!authorizeUrl) return
		window.location.replace(authorizeUrl)
	}, [authorizeUrl])

	if (authResult === 'success') {
		return (
			<main className="bank-auth-name-screen">
				<div className="bank-auth-mobile-result">
					<h1>Verificación completada</h1>
					<p>Ya puedes volver al ordenador y cerrar esta ventana.</p>
				</div>
			</main>
		)
	}

	if (!authorizeUrl) {
		return (
			<main className="bank-auth-name-screen">
				<div className="bank-auth-mobile-result">
					<h1>No se pudo verificar tu identidad</h1>
				</div>
			</main>
		)
	}

	return (
		<main className="bank-auth-name-screen">
			<div className="bank-auth-mobile-loading" aria-label="Cargando" />
		</main>
	)
}

export default MobileAuth
